// Traduções do assistente, coletadas por glob em core/i18n/messages.ts.
// Sem parêntese e sem travessão como separador: hierarquia por rótulo e valor.
export default {
  pt: {
    'assistente.botao': 'Assistente',
    'assistente.botao.dica': 'Assistente',
    'assistente.painel.rotulo': 'Assistente',
    'assistente.painel.titulo': 'Assistente',
    'assistente.painel.fechar': 'Fechar o assistente',
    'assistente.painel.historico': 'Histórico de conversas',
    'assistente.painel.voltar': 'Voltar à conversa',
    'assistente.painel.nova': 'Nova conversa',
    'assistente.painel.redimensionar': 'Redimensionar o painel',
    'assistente.conversa.nova': 'Nova conversa',
    'assistente.conversa.semTitulo': 'Sem título ainda',
    'assistente.conversa.editarTitulo': 'Editar o título da conversa',
    'assistente.conversa.tituloRotulo': 'Título da conversa',
    'assistente.conversa.arquivar': 'Arquivar',
    'assistente.conversa.apagar': 'Apagar',
    'assistente.conversa.acoes': 'Ações da conversa',
    'assistente.conversa.apagarTitulo': 'Apagar esta conversa?',
    'assistente.conversa.apagarTexto': 'A conversa e as respostas somem do histórico.',
    'assistente.conversa.carregarErro': 'Não foi possível abrir a conversa.',
    'assistente.historico.buscar': 'Buscar no histórico',
    'assistente.historico.vazio': 'Nenhuma conversa ainda',
    'assistente.historico.vazioDica': 'A primeira pergunta cria a primeira conversa.',
    'assistente.historico.semResultado': 'Nenhuma conversa com esse texto',
    'assistente.historico.erro': 'Não foi possível carregar o histórico.',
    'assistente.historico.abrir': 'Abrir a conversa {{titulo}}',
    'assistente.vazio.saudacao': 'Oi, {{nome}}.',
    'assistente.vazio.saudacaoSemNome': 'Oi.',
    'assistente.vazio.frase': 'Eu respondo sobre a operação consultando o Hub. Só leio, nunca altero nada.',
    'assistente.vazio.sugestoes': 'Perguntas para começar',
    'assistente.sugestoes.jornada.1': 'Quem teve mais hora extra neste período?',
    'assistente.sugestoes.jornada.2': 'Quantas infrações por base?',
    'assistente.sugestoes.jornada.3': 'Quem está com jornada aberta agora?',
    'assistente.sugestoes.historico.1': 'Resuma a semana deste colaborador',
    'assistente.sugestoes.historico.2': 'Quantos dias de folga ele teve no período?',
    'assistente.sugestoes.historico.3': 'Em que dias a jornada passou de 12h?',
    'assistente.sugestoes.diarias.1': 'Quais alertas seguem pendentes?',
    'assistente.sugestoes.diarias.2': 'Quem está com mais domingos seguidos?',
    'assistente.sugestoes.diarias.3': 'Quantas diárias ainda estão disponíveis para lançar?',
    'assistente.sugestoes.frente.1': 'Como está o andamento das cargas deste contrato?',
    'assistente.sugestoes.frente.2': 'Quantas cargas faltam para fechar o contrato?',
    'assistente.sugestoes.frente.3': 'Quais duplas estão escaladas hoje aqui?',
    'assistente.sugestoes.viagens.1': 'Qual o tempo médio por etapa neste período?',
    'assistente.sugestoes.viagens.2': 'Quantas viagens foram concluídas por dia?',
    'assistente.sugestoes.viagens.3': 'Qual dupla rodou mais quilômetros?',
    'assistente.sugestoes.hospedagem.1': 'Quem está hospedado hoje e em que quarto?',
    'assistente.sugestoes.hospedagem.2': 'Quais quartos estão com check-out vencido?',
    'assistente.sugestoes.hospedagem.3': 'Quanto foi gasto com hospedagem no mês?',
    'assistente.sugestoes.cadastros.1': 'Qual a situação deste cadastro?',
    'assistente.sugestoes.cadastros.2': 'Em que conjunto este veículo está hoje?',
    'assistente.sugestoes.cadastros.3': 'Qual foi a última jornada deste colaborador?',
    'assistente.sugestoes.mapa.1': 'Onde está este caminhão agora?',
    'assistente.sugestoes.mapa.2': 'Quais veículos estão parados com a ignição ligada?',
    'assistente.sugestoes.mapa.3': 'Quais veículos estão sem comunicar há mais de uma hora?',
    'assistente.sugestoes.mapa.4': 'Quantos caminhões estão em cada município agora?',
    'assistente.sugestoes.dashboard.1': 'Explique o indicador de ocupação',
    'assistente.sugestoes.dashboard.2': 'Quantas cargas foram solicitadas hoje?',
    'assistente.sugestoes.dashboard.3': 'Qual contrato está mais atrasado?',
    'assistente.sugestoes.geral.1': 'Quem teve mais hora extra neste mês?',
    'assistente.sugestoes.geral.2': 'Quantas infrações de jornada houve ontem?',
    'assistente.sugestoes.geral.3': 'Quem está com jornada aberta agora?',
    'assistente.composer.placeholder': 'Pergunte sobre a operação',
    'assistente.composer.rotulo': 'Sua pergunta',
    'assistente.composer.enviar': 'Enviar',
    'assistente.composer.parar': 'Parar',
    'assistente.composer.dica': 'Enter envia. Shift e Enter quebram a linha.',
    'assistente.contexto.falandoSobre': 'Falando sobre {{tela}}',
    'assistente.contexto.falandoSobreDetalhe': 'Falando sobre {{tela}}, {{detalhe}}',
    'assistente.contexto.periodo': '{{de}} a {{ate}}',
    'assistente.contexto.desligado': 'Pergunta solta, sem o contexto da tela',
    'assistente.contexto.interruptor': 'Enviar o contexto da tela junto com a pergunta',
    'assistente.etapas.contagem_one': '{{count}} etapa',
    'assistente.etapas.contagem_other': '{{count}} etapas',
    'assistente.etapas.mostrar': 'Mostrar as etapas',
    'assistente.etapas.ocultar': 'Ocultar as etapas',
    'assistente.etapa.buscar_conhecimento': 'Buscando a regra',
    'assistente.etapa.consultar_sql': 'Consultando o Hub',
    'assistente.etapa.andamento': 'em andamento',
    'assistente.etapa.concluida': 'concluída',
    'assistente.consulta.ver': 'Ver consulta',
    'assistente.consulta.ocultar': 'Ocultar consulta',
    'assistente.consulta.linhas_one': '{{count}} linha',
    'assistente.consulta.linhas_other': '{{count}} linhas',
    'assistente.consulta.objetivo': 'Objetivo',
    'assistente.consulta.copiar': 'Copiar SQL',
    'assistente.consulta.copiado': 'Copiado',
    'assistente.resposta.copiar': 'Copiar resposta',
    'assistente.resposta.copiado': 'Copiado',
    'assistente.resposta.util': 'Útil',
    'assistente.resposta.naoUtil': 'Não útil',
    'assistente.resposta.tentar': 'Tentar de novo',
    'assistente.resposta.oQueFaltou': 'O que faltou?',
    'assistente.resposta.enviarAvaliacao': 'Enviar avaliação',
    'assistente.resposta.avaliada': 'Avaliação registrada',
    'assistente.resposta.pensando': 'Preparando a resposta',
    'assistente.resposta.parada': 'Resposta interrompida.',
    'assistente.resposta.anuncio': 'Resposta do assistente pronta.',
    'assistente.erro.rede': 'Sem conexão com o servidor.',
    'assistente.erro.interrompido': 'A conexão caiu antes do fim da resposta.',
    'assistente.erro.generico': 'Não foi possível responder agora.',
    'assistente.erro.criarConversa': 'Não foi possível iniciar a conversa.',
    'assistente.limite.atingido': 'Limite diário de perguntas atingido.',
    'assistente.limite.voltaHoje': 'Volta hoje às {{hora}}.',
    'assistente.limite.voltaAmanha': 'Volta amanhã às {{hora}}.',
    'assistente.limite.voltaEm': 'Volta em {{data}} às {{hora}}.',
    'assistente.usuario.mensagem': 'Sua mensagem',
    'assistente.assistente.mensagem': 'Resposta do assistente',
    'assistente.painel.mais': 'Mais opções',
    'assistente.painel.arquivadas': 'Conversas arquivadas',
    'assistente.opcoes.mostrarEtapas': 'Mostrar as etapas',
    'assistente.opcoes.mostrarConsultas': 'Mostrar as consultas',
    'assistente.opcoes.apagarTudo': 'Apagar todas as conversas',
    'assistente.opcoes.apagarTudoTitulo': 'Apagar todas as conversas?',
    'assistente.opcoes.apagarTudoTexto': 'Todas as conversas, ativas e arquivadas, somem do histórico.',
    'assistente.historico.abas': 'Ativas ou arquivadas',
    'assistente.historico.ativas': 'Ativas',
    'assistente.historico.arquivadas': 'Arquivadas',
    'assistente.historico.vazioArquivadas': 'Nenhuma conversa arquivada',
    'assistente.conversa.desarquivar': 'Desarquivar',
    'assistente.turno.apagar': 'Apagar do histórico',
    'assistente.turno.apagarTitulo': 'Apagar esta pergunta e a resposta?',
    'assistente.turno.apagarTexto': 'As duas somem da conversa e o assistente deixa de considerá-las nas próximas respostas.',
    'assistente.usuario.editar': 'Editar e reenviar',
    'assistente.usuario.copiar': 'Copiar pergunta',
    'assistente.etapa.registrar_lacuna': 'Anotando o que faltou',
    'assistente.resposta.pensandoCurto': 'Pensando',
  },
  en: {
    'assistente.botao': 'Assistant',
    'assistente.botao.dica': 'Assistant',
    'assistente.painel.rotulo': 'Assistant',
    'assistente.painel.titulo': 'Assistant',
    'assistente.painel.fechar': 'Close the assistant',
    'assistente.painel.historico': 'Conversation history',
    'assistente.painel.voltar': 'Back to the conversation',
    'assistente.painel.nova': 'New conversation',
    'assistente.painel.redimensionar': 'Resize the panel',
    'assistente.conversa.nova': 'New conversation',
    'assistente.conversa.semTitulo': 'No title yet',
    'assistente.conversa.editarTitulo': 'Edit the conversation title',
    'assistente.conversa.tituloRotulo': 'Conversation title',
    'assistente.conversa.arquivar': 'Archive',
    'assistente.conversa.apagar': 'Delete',
    'assistente.conversa.acoes': 'Conversation actions',
    'assistente.conversa.apagarTitulo': 'Delete this conversation?',
    'assistente.conversa.apagarTexto': 'The conversation and its answers leave the history.',
    'assistente.conversa.carregarErro': 'The conversation could not be opened.',
    'assistente.historico.buscar': 'Search the history',
    'assistente.historico.vazio': 'No conversations yet',
    'assistente.historico.vazioDica': 'The first question starts the first conversation.',
    'assistente.historico.semResultado': 'No conversation matches that text',
    'assistente.historico.erro': 'The history could not be loaded.',
    'assistente.historico.abrir': 'Open the conversation {{titulo}}',
    'assistente.vazio.saudacao': 'Hi, {{nome}}.',
    'assistente.vazio.saudacaoSemNome': 'Hi.',
    'assistente.vazio.frase': 'I answer questions about the operation by reading the Hub. Read only, I never change anything.',
    'assistente.vazio.sugestoes': 'Questions to start with',
    'assistente.sugestoes.jornada.1': 'Who had the most overtime in this period?',
    'assistente.sugestoes.jornada.2': 'How many infractions per base?',
    'assistente.sugestoes.jornada.3': 'Who has an open shift right now?',
    'assistente.sugestoes.historico.1': 'Summarize this employee’s week',
    'assistente.sugestoes.historico.2': 'How many days off did they have in the period?',
    'assistente.sugestoes.historico.3': 'On which days did the shift exceed 12h?',
    'assistente.sugestoes.diarias.1': 'Which alerts are still pending?',
    'assistente.sugestoes.diarias.2': 'Who has the most consecutive Sundays?',
    'assistente.sugestoes.diarias.3': 'How many allowances are still available to enter?',
    'assistente.sugestoes.frente.1': 'How are the loads of this contract going?',
    'assistente.sugestoes.frente.2': 'How many loads are left to close the contract?',
    'assistente.sugestoes.frente.3': 'Which pairs are scheduled here today?',
    'assistente.sugestoes.viagens.1': 'What is the average time per stage in this period?',
    'assistente.sugestoes.viagens.2': 'How many trips were completed per day?',
    'assistente.sugestoes.viagens.3': 'Which pair drove the most kilometers?',
    'assistente.sugestoes.hospedagem.1': 'Who is lodged today and in which room?',
    'assistente.sugestoes.hospedagem.2': 'Which rooms have an overdue check-out?',
    'assistente.sugestoes.hospedagem.3': 'How much was spent on lodging this month?',
    'assistente.sugestoes.cadastros.1': 'What is the status of this record?',
    'assistente.sugestoes.cadastros.2': 'Which set is this vehicle in today?',
    'assistente.sugestoes.cadastros.3': 'What was this employee’s last shift?',
    'assistente.sugestoes.mapa.1': 'Where is this truck right now?',
    'assistente.sugestoes.mapa.2': 'Which vehicles are stopped with the ignition on?',
    'assistente.sugestoes.mapa.3': 'Which vehicles have not reported for over an hour?',
    'assistente.sugestoes.mapa.4': 'How many trucks are in each municipality right now?',
    'assistente.sugestoes.dashboard.1': 'Explain the occupancy indicator',
    'assistente.sugestoes.dashboard.2': 'How many loads were requested today?',
    'assistente.sugestoes.dashboard.3': 'Which contract is the most delayed?',
    'assistente.sugestoes.geral.1': 'Who had the most overtime this month?',
    'assistente.sugestoes.geral.2': 'How many shift infractions were there yesterday?',
    'assistente.sugestoes.geral.3': 'Who has an open shift right now?',
    'assistente.composer.placeholder': 'Ask about the operation',
    'assistente.composer.rotulo': 'Your question',
    'assistente.composer.enviar': 'Send',
    'assistente.composer.parar': 'Stop',
    'assistente.composer.dica': 'Enter sends. Shift and Enter add a line break.',
    'assistente.contexto.falandoSobre': 'Talking about {{tela}}',
    'assistente.contexto.falandoSobreDetalhe': 'Talking about {{tela}}, {{detalhe}}',
    'assistente.contexto.periodo': '{{de}} to {{ate}}',
    'assistente.contexto.desligado': 'Standalone question, without the screen context',
    'assistente.contexto.interruptor': 'Send the screen context with the question',
    'assistente.etapas.contagem_one': '{{count}} step',
    'assistente.etapas.contagem_other': '{{count}} steps',
    'assistente.etapas.mostrar': 'Show the steps',
    'assistente.etapas.ocultar': 'Hide the steps',
    'assistente.etapa.buscar_conhecimento': 'Looking up the rule',
    'assistente.etapa.consultar_sql': 'Querying the Hub',
    'assistente.etapa.andamento': 'in progress',
    'assistente.etapa.concluida': 'done',
    'assistente.consulta.ver': 'View query',
    'assistente.consulta.ocultar': 'Hide query',
    'assistente.consulta.linhas_one': '{{count}} row',
    'assistente.consulta.linhas_other': '{{count}} rows',
    'assistente.consulta.objetivo': 'Purpose',
    'assistente.consulta.copiar': 'Copy SQL',
    'assistente.consulta.copiado': 'Copied',
    'assistente.resposta.copiar': 'Copy answer',
    'assistente.resposta.copiado': 'Copied',
    'assistente.resposta.util': 'Helpful',
    'assistente.resposta.naoUtil': 'Not helpful',
    'assistente.resposta.tentar': 'Try again',
    'assistente.resposta.oQueFaltou': 'What was missing?',
    'assistente.resposta.enviarAvaliacao': 'Send feedback',
    'assistente.resposta.avaliada': 'Feedback recorded',
    'assistente.resposta.pensando': 'Preparing the answer',
    'assistente.resposta.parada': 'Answer stopped.',
    'assistente.resposta.anuncio': 'Assistant answer ready.',
    'assistente.erro.rede': 'No connection to the server.',
    'assistente.erro.interrompido': 'The connection dropped before the answer ended.',
    'assistente.erro.generico': 'The assistant could not answer right now.',
    'assistente.erro.criarConversa': 'The conversation could not be started.',
    'assistente.limite.atingido': 'Daily question limit reached.',
    'assistente.limite.voltaHoje': 'Back today at {{hora}}.',
    'assistente.limite.voltaAmanha': 'Back tomorrow at {{hora}}.',
    'assistente.limite.voltaEm': 'Back on {{data}} at {{hora}}.',
    'assistente.usuario.mensagem': 'Your message',
    'assistente.assistente.mensagem': 'Assistant answer',
    'assistente.painel.mais': 'More options',
    'assistente.painel.arquivadas': 'Archived conversations',
    'assistente.opcoes.mostrarEtapas': 'Show the steps',
    'assistente.opcoes.mostrarConsultas': 'Show the queries',
    'assistente.opcoes.apagarTudo': 'Delete all conversations',
    'assistente.opcoes.apagarTudoTitulo': 'Delete all conversations?',
    'assistente.opcoes.apagarTudoTexto': 'Every conversation, active and archived, leaves the history.',
    'assistente.historico.abas': 'Active or archived',
    'assistente.historico.ativas': 'Active',
    'assistente.historico.arquivadas': 'Archived',
    'assistente.historico.vazioArquivadas': 'No archived conversations',
    'assistente.conversa.desarquivar': 'Unarchive',
    'assistente.turno.apagar': 'Delete from history',
    'assistente.turno.apagarTitulo': 'Delete this question and its answer?',
    'assistente.turno.apagarTexto': 'Both leave the conversation and the assistant stops considering them in the next answers.',
    'assistente.usuario.editar': 'Edit and resend',
    'assistente.usuario.copiar': 'Copy question',
    'assistente.etapa.registrar_lacuna': 'Noting what was missing',
    'assistente.resposta.pensandoCurto': 'Thinking',
  },
  es: {
    'assistente.botao': 'Asistente',
    'assistente.botao.dica': 'Asistente',
    'assistente.painel.rotulo': 'Asistente',
    'assistente.painel.titulo': 'Asistente',
    'assistente.painel.fechar': 'Cerrar el asistente',
    'assistente.painel.historico': 'Historial de conversaciones',
    'assistente.painel.voltar': 'Volver a la conversación',
    'assistente.painel.nova': 'Nueva conversación',
    'assistente.painel.redimensionar': 'Cambiar el ancho del panel',
    'assistente.conversa.nova': 'Nueva conversación',
    'assistente.conversa.semTitulo': 'Sin título todavía',
    'assistente.conversa.editarTitulo': 'Editar el título de la conversación',
    'assistente.conversa.tituloRotulo': 'Título de la conversación',
    'assistente.conversa.arquivar': 'Archivar',
    'assistente.conversa.apagar': 'Eliminar',
    'assistente.conversa.acoes': 'Acciones de la conversación',
    'assistente.conversa.apagarTitulo': '¿Eliminar esta conversación?',
    'assistente.conversa.apagarTexto': 'La conversación y sus respuestas salen del historial.',
    'assistente.conversa.carregarErro': 'No se pudo abrir la conversación.',
    'assistente.historico.buscar': 'Buscar en el historial',
    'assistente.historico.vazio': 'Ninguna conversación todavía',
    'assistente.historico.vazioDica': 'La primera pregunta crea la primera conversación.',
    'assistente.historico.semResultado': 'Ninguna conversación con ese texto',
    'assistente.historico.erro': 'No se pudo cargar el historial.',
    'assistente.historico.abrir': 'Abrir la conversación {{titulo}}',
    'assistente.vazio.saudacao': 'Hola, {{nome}}.',
    'assistente.vazio.saudacaoSemNome': 'Hola.',
    'assistente.vazio.frase': 'Respondo sobre la operación consultando el Hub. Solo leo, nunca cambio nada.',
    'assistente.vazio.sugestoes': 'Preguntas para empezar',
    'assistente.sugestoes.jornada.1': '¿Quién tuvo más horas extra en este período?',
    'assistente.sugestoes.jornada.2': '¿Cuántas infracciones por base?',
    'assistente.sugestoes.jornada.3': '¿Quién tiene la jornada abierta ahora?',
    'assistente.sugestoes.historico.1': 'Resume la semana de este colaborador',
    'assistente.sugestoes.historico.2': '¿Cuántos días libres tuvo en el período?',
    'assistente.sugestoes.historico.3': '¿En qué días la jornada pasó de 12h?',
    'assistente.sugestoes.diarias.1': '¿Qué alertas siguen pendientes?',
    'assistente.sugestoes.diarias.2': '¿Quién tiene más domingos seguidos?',
    'assistente.sugestoes.diarias.3': '¿Cuántos viáticos siguen disponibles para registrar?',
    'assistente.sugestoes.frente.1': '¿Cómo va el avance de las cargas de este contrato?',
    'assistente.sugestoes.frente.2': '¿Cuántas cargas faltan para cerrar el contrato?',
    'assistente.sugestoes.frente.3': '¿Qué duplas están programadas aquí hoy?',
    'assistente.sugestoes.viagens.1': '¿Cuál es el tiempo medio por etapa en este período?',
    'assistente.sugestoes.viagens.2': '¿Cuántos viajes se concluyeron por día?',
    'assistente.sugestoes.viagens.3': '¿Qué dupla recorrió más kilómetros?',
    'assistente.sugestoes.hospedagem.1': '¿Quién está hospedado hoy y en qué habitación?',
    'assistente.sugestoes.hospedagem.2': '¿Qué habitaciones tienen el check-out vencido?',
    'assistente.sugestoes.hospedagem.3': '¿Cuánto se gastó en hospedaje este mes?',
    'assistente.sugestoes.cadastros.1': '¿Cuál es la situación de este registro?',
    'assistente.sugestoes.cadastros.2': '¿En qué conjunto está este vehículo hoy?',
    'assistente.sugestoes.cadastros.3': '¿Cuál fue la última jornada de este colaborador?',
    'assistente.sugestoes.mapa.1': '¿Dónde está este camión ahora?',
    'assistente.sugestoes.mapa.2': '¿Qué vehículos están parados con el encendido activado?',
    'assistente.sugestoes.mapa.3': '¿Qué vehículos llevan más de una hora sin comunicar?',
    'assistente.sugestoes.mapa.4': '¿Cuántos camiones hay en cada municipio ahora?',
    'assistente.sugestoes.dashboard.1': 'Explica el indicador de ocupación',
    'assistente.sugestoes.dashboard.2': '¿Cuántas cargas se solicitaron hoy?',
    'assistente.sugestoes.dashboard.3': '¿Qué contrato está más atrasado?',
    'assistente.sugestoes.geral.1': '¿Quién tuvo más horas extra este mes?',
    'assistente.sugestoes.geral.2': '¿Cuántas infracciones de jornada hubo ayer?',
    'assistente.sugestoes.geral.3': '¿Quién tiene la jornada abierta ahora?',
    'assistente.composer.placeholder': 'Pregunta sobre la operación',
    'assistente.composer.rotulo': 'Tu pregunta',
    'assistente.composer.enviar': 'Enviar',
    'assistente.composer.parar': 'Detener',
    'assistente.composer.dica': 'Enter envía. Shift y Enter saltan de línea.',
    'assistente.contexto.falandoSobre': 'Hablando de {{tela}}',
    'assistente.contexto.falandoSobreDetalhe': 'Hablando de {{tela}}, {{detalhe}}',
    'assistente.contexto.periodo': '{{de}} a {{ate}}',
    'assistente.contexto.desligado': 'Pregunta suelta, sin el contexto de la pantalla',
    'assistente.contexto.interruptor': 'Enviar el contexto de la pantalla con la pregunta',
    'assistente.etapas.contagem_one': '{{count}} etapa',
    'assistente.etapas.contagem_other': '{{count}} etapas',
    'assistente.etapas.mostrar': 'Mostrar las etapas',
    'assistente.etapas.ocultar': 'Ocultar las etapas',
    'assistente.etapa.buscar_conhecimento': 'Buscando la regla',
    'assistente.etapa.consultar_sql': 'Consultando el Hub',
    'assistente.etapa.andamento': 'en curso',
    'assistente.etapa.concluida': 'concluida',
    'assistente.consulta.ver': 'Ver consulta',
    'assistente.consulta.ocultar': 'Ocultar consulta',
    'assistente.consulta.linhas_one': '{{count}} fila',
    'assistente.consulta.linhas_other': '{{count}} filas',
    'assistente.consulta.objetivo': 'Objetivo',
    'assistente.consulta.copiar': 'Copiar SQL',
    'assistente.consulta.copiado': 'Copiado',
    'assistente.resposta.copiar': 'Copiar respuesta',
    'assistente.resposta.copiado': 'Copiado',
    'assistente.resposta.util': 'Útil',
    'assistente.resposta.naoUtil': 'No útil',
    'assistente.resposta.tentar': 'Intentar de nuevo',
    'assistente.resposta.oQueFaltou': '¿Qué faltó?',
    'assistente.resposta.enviarAvaliacao': 'Enviar valoración',
    'assistente.resposta.avaliada': 'Valoración registrada',
    'assistente.resposta.pensando': 'Preparando la respuesta',
    'assistente.resposta.parada': 'Respuesta interrumpida.',
    'assistente.resposta.anuncio': 'Respuesta del asistente lista.',
    'assistente.erro.rede': 'Sin conexión con el servidor.',
    'assistente.erro.interrompido': 'La conexión se cortó antes del final de la respuesta.',
    'assistente.erro.generico': 'No se pudo responder ahora.',
    'assistente.erro.criarConversa': 'No se pudo iniciar la conversación.',
    'assistente.limite.atingido': 'Límite diario de preguntas alcanzado.',
    'assistente.limite.voltaHoje': 'Vuelve hoy a las {{hora}}.',
    'assistente.limite.voltaAmanha': 'Vuelve mañana a las {{hora}}.',
    'assistente.limite.voltaEm': 'Vuelve el {{data}} a las {{hora}}.',
    'assistente.usuario.mensagem': 'Tu mensaje',
    'assistente.assistente.mensagem': 'Respuesta del asistente',
    'assistente.painel.mais': 'Más opciones',
    'assistente.painel.arquivadas': 'Conversaciones archivadas',
    'assistente.opcoes.mostrarEtapas': 'Mostrar las etapas',
    'assistente.opcoes.mostrarConsultas': 'Mostrar las consultas',
    'assistente.opcoes.apagarTudo': 'Eliminar todas las conversaciones',
    'assistente.opcoes.apagarTudoTitulo': '¿Eliminar todas las conversaciones?',
    'assistente.opcoes.apagarTudoTexto': 'Todas las conversaciones, activas y archivadas, desaparecen del historial.',
    'assistente.historico.abas': 'Activas o archivadas',
    'assistente.historico.ativas': 'Activas',
    'assistente.historico.arquivadas': 'Archivadas',
    'assistente.historico.vazioArquivadas': 'Ninguna conversación archivada',
    'assistente.conversa.desarquivar': 'Desarchivar',
    'assistente.turno.apagar': 'Eliminar del historial',
    'assistente.turno.apagarTitulo': '¿Eliminar esta pregunta y la respuesta?',
    'assistente.turno.apagarTexto': 'Las dos desaparecen de la conversación y el asistente deja de considerarlas en las próximas respuestas.',
    'assistente.usuario.editar': 'Editar y reenviar',
    'assistente.usuario.copiar': 'Copiar pregunta',
    'assistente.etapa.registrar_lacuna': 'Anotando lo que faltó',
    'assistente.resposta.pensandoCurto': 'Pensando',
  },
}
